export default __webpack_public_path__ + "static/media/star.fc47d640.svg";